import { useQuery } from "@tanstack/react-query";
import { useApi, type BusinessDTO } from "api";

export const useBusiness = ({ id }: { id?: BusinessDTO["id"] }) => {
  const { api } = useApi();

  const query = useQuery({
    queryKey: ["business", id],
    queryFn: () => api.publicBusiness.getById(id!),
    enabled: !!id,
  });

  return {
    loading: query.isFetching,
    loaded: query.isFetched,
    business: query.data,
  };
};
